import { createSelector } from 'reselect';

import getAllDocuments from './getAllDocuments';

const getAllCylinderWarps = createSelector([getAllDocuments], (documents) =>
    documents.filter((doc) => doc.cylinder).map((doc) => ({ id: doc.id, ...doc.cylinder })),
);

export default getAllCylinderWarps;
